import Cookies from 'js-cookie';
import { FaqDataAdd, FaqDataUpd } from './types';

const API = import.meta.env.VITE_API_BASE_URL;

export const fetchGetFaq = async () => {
	try {
		const response = await fetch(`${API}/faq`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const fetchAddFaq = async ({ token, title, content, isHidden }: FaqDataAdd) => {
	try {
		const formData = new FormData();

		formData.append('action', 'create');
		formData.append('session_id', token);
		formData.append('title', title);
		formData.append('content', content);
		formData.append('is_hidden', `${isHidden}`);
		formData.append('author_id', Cookies.get('author_id') || '');

		const response = await fetch(`${API}/faq/edit`, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');
		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const fetchUpdFaq = async ({ token, id, title, content, isHidden }: FaqDataUpd) => {
	try {
		const formData = new FormData();

		formData.append('action', 'edit');
		formData.append('session_id', token);
		formData.append('id', id);
		formData.append('title', title ?? '');
		formData.append('content', content ?? '');
		formData.append('is_hidden', `${isHidden}`);
		formData.append('author_id', Cookies.get('author_id') || '');

		const response = await fetch(`${API}/faq/edit`, {
			method: 'POST',

			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const fetchDeleteFaq = async ({ id, token }: { id: string; token: string }) => {
	try {
		const formData = new FormData();

		formData.append('action', 'delete');
		formData.append('session_id', token);
		formData.append('id', id);

		const response = await fetch(`${API}/faq/edit`, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
